export default __webpack_public_path__ + "svg/CompaniesLogos/logo_bhub.svg?47aea50e";